<template>
  <div class="table-skeleton">
    <b-skeleton-table
      :rows="rows"
      :columns="columns.length"
      :table-props="{ striped: true, responsive: true }"
      animated
    />
  </div>
</template>

<script>
import { BSkeletonTable } from 'bootstrap-vue';

export default {
  name: 'TableSkeleton',
  components: {
    BSkeletonTable,
  },
  props: {
    columns: {
      type: Array,
      required: true,
    },
    rows: {
      type: Number,
      default: 5,
    },
  },
};
</script>

<style lang="scss" scoped>
.table-skeleton {
  min-width: 100%;
}
</style>
